import React from 'react';
import { CheckIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  className?: string;
};
export function CheckItem({
  children,
  className = ''
}: CheckItemProps) {
  return <li className={`flex items-start gap-2.5 ${className}`} data-id="element-21" data-mp="2746an5r9q6ej">
      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded bg-accent-500 text-carbon-950" data-id="element-22" data-mp="271k2p50gtovs">
        <CheckIcon className="h-3 w-3" strokeWidth={3.5} aria-hidden="true" data-id="element-23" data-mp="1x5gv3jmugy1g" />
      </span>
      <span data-id="element-24" data-mp="2241tremg79ns">{children}</span>
    </li>;
}